import { pickerDialogActions } from '@common-reducers/PickerDialogReducer';
import { cellValueSelector } from '@common-reducers/TaskSelectors';
import { updateCellValueThunk } from '@common-reducers/TaskThunks';
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import { createElement, memo } from 'react';
import { CellProps, CellWrapperProps, OpenPickerOptions, PickerProps } from './cell-interface';
import { isTempId } from "@common-reducers/DBServiceThunks";
import { Skeleton } from '@mui/material';

function CellWrapper({
    columnId,
    columnType,
    taskId,
    groupId,
    boardId,
    cellComponent,
    isFormInEditMode,
    isOnKanban = false,
    sx,
    mockValue,
    readOnly = false,
    pickerPlacement
}: CellWrapperProps) {

    const dispatch = useAppDispatch()
    const cellValue = useAppSelector((state) => cellValueSelector(state, taskId, columnId)) ?? mockValue

    const updateTask = (value: unknown) => {
        dispatch(updateCellValueThunk({
            taskId: taskId ?? null,
            columnId: columnId ?? null,
            data: {
                value
            }
        }));
    }

    const closePicker = () => {
        pickerDialogActions.closePickerDialog();
    }

    const togglePicker = ({
        anchorId,
        pickerType,
        placement
    }: OpenPickerOptions) => {
        if (readOnly) return;
        dispatch(pickerDialogActions.togglePicker({
            pickerAnchorId: anchorId,
            pickerProps: {
                cellValue,
                columnId,
                taskId,
                groupId,
                boardId,
                isFormInEditMode,
                type: pickerType,
                placement
            } as PickerProps
        }))
    }

    const openPicker = ({
        anchorId,
        pickerType,
        placement
    }: OpenPickerOptions) => {
        if (readOnly) return;
        dispatch(
            pickerDialogActions.setPickerTypeAndId({
                pickerAnchorId: anchorId,
                pickerProps: {
                    cellValue,
                    columnId,
                    taskId,
                    groupId,
                    boardId,
                    isFormInEditMode,
                    type: pickerType,
                    placement
                } as PickerProps
            })
        )
    }

    return createElement(cellComponent, {
        cellValue,
        taskId,
        groupId,
        columnId,
        boardId,
        isFormInEditMode,
        isOnKanban,
        sx,
        readOnly,
        mockValue,
        pickerPlacement,
        onUpdate: updateTask,
        openPicker,
        togglePicker,
        closePicker
    } as CellProps);
}

export default memo(CellWrapper);